/*
 * TN ClearMorning – product template behaviour.
 * 1. Links ending in "#tn-buy" scroll smoothly to the main buy card and focus the ATC.
 * 2. The sticky add-to-cart hides while the main ATC button is on screen
 *    (setting "Hide sticky add-to-cart while the main button is on screen").
 */
(function () {
  function mainAtc() {
    return document.querySelector('.main-product-section .product-form__submit');
  }

  function buyTarget() {
    var atc = mainAtc();
    if (!atc) return document.querySelector('product-info');
    return atc.closest('.slide-item') || atc.closest('product-form') || atc;
  }

  function scrollToBuy(event) {
    var link = event.target.closest('a[href$="#tn-buy"]');
    if (!link) return;
    var target = buyTarget();
    if (!target) return;
    event.preventDefault();
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var atc = mainAtc();
    if (atc) {
      window.setTimeout(function () {
        atc.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 600);
    }
  }

  function watchStickyAtc() {
    var config = document.querySelector('.tn-cm-style');
    var sticky = document.querySelector('sticky-atc');
    if (!sticky) return;
    sticky.classList.add('tn-sticky-desktop-off');
    if (!config || config.dataset.hideStickyNearAtc !== 'true') return;
    var atc = mainAtc();
    if (!atc || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('tn-sticky-hidden', entry.isIntersecting);
      });
    });
    observer.observe(atc);
  }

  function init() {
    document.addEventListener('click', scrollToBuy);
    watchStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
